//
//

import { mapGetters, mapActions } from "vuex";
import ApplicationsPage from "@/components/apps/applicationsPage/applicationsPage.vue";
import NoAppsPage from "@/components/apps/noAppsPage/noAppsPage.vue";

export default {
    name: "AppsMainPage",
    components: {
        "application-apps": ApplicationsPage,
        "no-apps": NoAppsPage
    },
    data() {
        return {
            pageName: "appsMainPage",
            showEmptyState: false,
            loading: true,
            firstLoad: true
        };
    },
    computed: {
        ...mapGetters("apps", ["noAppsToShow", "getAppWasArchived"])
    },
    activated() {
        if (this.firstLoad) {
            this.firstLoad = false;
        } else {
            this.getApps();
        }
    },
    mounted() {
        this.getApps();
        if (this.getAppWasArchived && this.firstLoad) {
            this.firstLoad = false;
            this.$store.commit("apps/setAppWasArchived", false);
        }
    },
    methods: {
        ...mapActions("apps", ["getAppsNumber"]),
        getApps() {
            this.getAppsNumber().then(() => {
                this.showEmptyState = this.noAppsToShow;
                this.loading = false;
            });
        }
    }
};
